import {
    createSlice
}
    from '@reduxjs/toolkit';

const initialState = {
    sortByText: "Last Updated Date",
    sortBy: 1,
    ascending: false,
    open: false,
    sortItems: [
        {
            text: "Last Updated Date",
            value: 1
        },
        {
            text: "Applied Date",
            value: 2
        }
    ]
};

export const applicantSorterSlice = createSlice({
    name: 'applicantSorter',
    initialState,
    reducers: {
        updateAscending: (state, action) => {
            state.ascending = action.payload;
        },
        toggleMenu: (state, action) => {
            state.open = action.payload;
        },
        toggleAscending: (state, action) => {
            state.ascending = action.payload;
        },
        setSortItem: (state, action) => {
            const { sortByText, sortBy, open } = action.payload;
            state.sortByText = sortByText;
            state.sortBy = sortBy;
            state.open = open;
        },
        hideMenu: state => {
            state.open = false;
        }
    }
});

export const { updateAscending, setSortItem, toggleMenu, toggleAscending, hideMenu } = applicantSorterSlice.actions;

export default applicantSorterSlice.reducer

export const selectApplicantSorterDetail = state => {
    return {
        sortByText: state.applicantSorter.sortByText,
        sortBy: state.applicantSorter.sortBy,
        ascending: state.applicantSorter.ascending,
        open: state.applicantSorter.open,
        sortByItems: state.applicantSorter.sortItems
    }
}

export const selectSort = state => {
    return {
        by: state.applicantSorter.sortBy,
        ascending: state.applicantSorter.ascending
    }
};
